var Deals;
(function (Deals) {
    document.addEventListener('ControllerReady', function () {
        var _a, _b, _c, _d;
        const $dealsContainer = document.querySelector('.wrapper-services-conventions');
        if ($dealsContainer) {
            const $containerSlide = $dealsContainer.querySelector('.slide-container.deal');
            const $slide = $dealsContainer.querySelector('.slide.type-3');
            const $button = $dealsContainer.querySelector('.banner-btn .btn');
            const $modal = document.querySelector('.modal-services-conventions .modal');
            const $closeModal = document.querySelector('.modal-services-conventions .icn-close');
            const $loadMore = document.querySelector('[data-load-more]');
            const searchParams = new URLSearchParams(location.search);
            const queryText = searchParams.get('query') || '';
            const queryAmbit = searchParams.get('cat') || false;
            let sortType = 'vistanaz';
            let deskImgInput = document.querySelector('#img-bck-dsk');
            let mobImgInput = document.querySelector('#img-bck-mob');
            if (queryAmbit) {
                (_a = document.querySelector('#ambits').parentElement) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
                if ($dealsContainer.querySelectorAll(`.deals-category-list .box[id="${queryAmbit}"] picture > img`).length > 1) {
                    if (isMobile()) {
                        mobImgInput.src = $dealsContainer.querySelectorAll(`.deals-category-list .box[id="${queryAmbit}"] picture > img`)[2].getAttribute('src');
                    }
                    else {
                        deskImgInput.src = (_b = $dealsContainer.querySelectorAll(`.deals-category-list .box[id="${queryAmbit}"] picture > img`)[1]) === null || _b === void 0 ? void 0 : _b.getAttribute('src');
                    }
                }
                document.querySelector('#title').innerHTML = (_c = $dealsContainer.querySelectorAll(`.deals-category-list .box[id="${queryAmbit}"] span`)[0]) === null || _c === void 0 ? void 0 : _c.innerHTML;
                document.querySelector('#subtitle').innerHTML = (_d = $dealsContainer.querySelectorAll(`.deals-category-list .box[id="${queryAmbit}"] span`)[1]) === null || _d === void 0 ? void 0 : _d.innerHTML;
            }
            const pageCount = 12;
            let config;
            let currPage = 0;
            let filters = {};
            function getDeals() {
                const data = config || retrieveConfig($dealsContainer);
                const headers = data.config.headers || {};
                config = data;
                return Fetch(data.url + '/search', {
                    headers: {
                        ...headers,
                    },
                    data: {
                        offset: currPage * pageCount,
                        limit: pageCount,
                        sort: sortType,
                        ...filters,
                    },
                })
                    .then(deals => {
                    if (currPage * pageCount + pageCount < deals.pagedata.total) {
                        currPage++;
                        $loadMore.querySelector('.text').innerHTML = `Hai visualizzato <b>${currPage *
                            pageCount}</b> elementi`;
                        $loadMore.classList.remove('hidden');
                    }
                    else {
                        $loadMore.classList.add('hidden');
                    }
                    buildDeals(deals.convenzioni || []);
                })
                    .catch((err) => {
                    _flog(0, err, {
                        url: data.url + '/search',
                        offset: currPage * pageCount,
                        limit: pageCount,
                        sort: sortType,
                        ...filters,
                    }, {});
                })
                    .finally(() => {
                    $dealsContainer
                        .querySelector('.container-train-card')
                        .removeAttribute('data-spinner');
                });
            }
            function showModal() {
                $modal.classList.add('active');
                document.body.style.overflow = 'hidden';
                document.querySelector('#header').style.position = 'fixed';
            }
            function hiddenModal() {
                $modal.classList.remove('active');
                document.body.style.overflow = 'auto';
                document.querySelector('#header').style.position = 'initial';
            }
            function retrieveConfig($wrapper) {
                let data = {};
                const $form = $wrapper && $wrapper.querySelector('.ep-config');
                if ($form) {
                    try {
                        const url = $form.querySelector('[name="url"]').value;
                        const config = $form.querySelector('[name="config"]').value;
                        data = {
                            url: url.replace(/\/$/, ''),
                            config: JSON.parse(config),
                        };
                    }
                    catch (e) {
                        console.log('Error during retrieval of configuration for current service. %s', e);
                    }
                }
                return data;
            }
            function buildDeals(deals) {
                if (deals.length) {
                    $dealsContainer.querySelector('.no-results').classList.add('d-none');
                    deals.forEach(deal => {
                        var _a;
                        let $nextDeal = $slide.cloneNode(true);
                        $nextDeal.id = deal.id;
                        let image = '';
                        if (deal.immagini.length) {
                            deal.immagini.forEach(img => {
                                if (img.tipo === 'COMPATTA') {
                                    image = `<img src="${(img === null || img === void 0 ? void 0 : img.url) || 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='}">`;
                                }
                            });
                        }
                        else {
                            $nextDeal.querySelector('.image').classList.add('is-icon');
                            let category = $dealsContainer.querySelector(`.deals-category-list .box[id="${deal.ambiti[0].id}"] picture > img image-box`);
                            category = category && category.getAttribute('src') || '';
                            image = `<img src="${category || 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='}">`;
                        }
                        $nextDeal.querySelector('.image').innerHTML = image + `<div class="category">${(_a = deal.ambiti[0]) === null || _a === void 0 ? void 0 : _a.titolo}</div>`;
                        $nextDeal.querySelector('.heading .title').innerHTML = deal.titolo;
                        $nextDeal.querySelector('.body .description').innerHTML = deal.desc_breve;
                        if (deal.valida_da || deal.valida_a) {
                            let dateFrom = deal.valida_da && `dal: <b>${new Date(deal.valida_da).toLocaleDateString()}</b>` || '';
                            let dateTo = deal.valida_a && `al: <b>${new Date(deal.valida_a).toLocaleDateString()}</b>` || '';
                            $nextDeal.querySelector('.due-date').innerHTML = `Valida ${dateFrom} ${dateTo}`;
                        }
                        $nextDeal.querySelector('.footer .discount').innerHTML = (deal.vantaggio && deal.vantaggio.vantaggio_applicato) || '<span class="generic">Scopri i vantaggi riservati a te</span>';
                        const sedi = deal.sedi;
                        if (sedi) {
                            const $containerPosition = $nextDeal.querySelector('.body .container-position');
                            const $position = $containerPosition.querySelector('.position.dummy');
                            sedi.slice(0, 2).forEach(position => {
                                let $nextPosition = $position.cloneNode(true);
                                $nextPosition.querySelector('.text').innerHTML = `${position.denominazione_sede} - ${position.citta}, (${position.provincia})`;
                                $nextPosition.classList.remove('dummy');
                                $containerPosition.appendChild($nextPosition);
                            });
                            if (sedi.length > 2) {
                                let $nextPosition = $position.cloneNode(true);
                                $nextPosition.querySelector('.text').innerHTML = `+ altri ${sedi.length - 2}`;
                                $nextPosition.classList.remove('dummy');
                                $containerPosition.appendChild($nextPosition);
                            }
                        }
                        $nextDeal.classList.remove('dummy');
                        $containerSlide.appendChild($nextDeal);
                        let url = '/vantaggi-e-servizi/convenzioni/' + deal.id + '/' + deal.titolo.replace(/[^a-zA-Z0-9\s\-_]/gmi, '').replace(/\s/gmi, '-');
                        $nextDeal.addEventListener('click', () => {
                            location.href = url;
                        });
                    });
                }
                else {
                    $dealsContainer.querySelector('.no-results').classList.remove('d-none');
                }
            }
            function initFilters() {
                const $ambits = document.querySelector('#ambits');
                const $query = document.querySelector('#text-query');
                const $queryInput = $query.querySelector('input');
                const $queryClose = $query.querySelector('.icn-close');
                const $valid = document.querySelector('#valid');
                const $national = document.querySelector('#nationals');
                const $cooperatives = document.querySelector('#cooperatives');
                const data = config || retrieveConfig($dealsContainer);
                config = data;
                Fetch(data.url + '/ambits', {
                    headers: {
                        ...data.config.headers,
                    },
                })
                    .then(items => {
                    if (items && items.length) {
                        items.forEach(item => {
                            const option = document.createElement('option');
                            option.value = item.id;
                            option.innerText = item.titolo;
                            if (queryAmbit && queryAmbit !== '#' && queryAmbit === item.id.toString()) {
                                option.selected = true;
                            }
                            $ambits.appendChild(option);
                        });
                        const ambits = tail.select($ambits, {
                            hideSelected: false,
                            locale: 'it',
                            search: items.length >= 5,
                            multiple: true,
                            placeholder: 'Seleziona ambito',
                        });
                        toggleFiltersHeight(ambits);
                        ambits.on('change', () => {
                            const values = ambits.value();
                            if (values) {
                                filters['ambits'] = values.join(',');
                            }
                            else {
                                delete filters['ambits'];
                            }
                            clearResults();
                            getDeals();
                        });
                    }
                    else {
                        $ambits.remove();
                    }
                })
                    .catch((err) => {
                    $ambits.remove();
                    _flog(0, err, { url: data.url + '/ambits' }, {});
                })
                    .finally(() => {
                    $dealsContainer.querySelector('.filters').classList.add('is-active');
                });
                $queryInput.addEventListener('keyup', debounce(() => {
                    if ($queryInput.value.length >= 3) {
                        filters['query'] = $queryInput.value;
                        clearResults();
                        getDeals();
                    }
                    if ($queryInput.value.length == 0) {
                        delete filters['query'];
                        clearResults();
                        getDeals();
                    }
                }, 250));
                $queryClose.addEventListener('click', () => {
                    if ($queryInput.value) {
                        $queryInput.value = '';
                        delete filters['query'];
                        clearResults();
                        getDeals();
                    }
                });
                const cooperatives = tail.select($cooperatives, {
                    placeholder: 'Seleziona Cooperativa',
                    locale: 'it',
                });
                toggleFiltersHeight(cooperatives);
                cooperatives.on('change', () => {
                    const value = cooperatives.value();
                    if (value) {
                        filters['cooperativaId'] = value;
                        sortType = 'vistaloc';
                    }
                    else {
                        delete filters['cooperativaId'];
                        sortType = 'vistanaz';
                    }
                    clearResults();
                    getDeals();
                });
                if (queryAmbit && queryAmbit !== '#') {
                    filters['ambits'] = parseInt(queryAmbit);
                }
                if (queryText) {
                    filters['query'] = queryText;
                    $queryInput.value = queryText;
                }
            }
            function toggleFiltersHeight(filter) {
                filter.on('open', () => {
                    $dealsContainer.querySelector('.filters').classList.add('is-filter');
                });
                filter.on('close', () => {
                    $dealsContainer.querySelector('.filters').classList.remove('is-filter');
                });
            }
            function clearResults() {
                currPage = 0;
                $containerSlide.innerHTML = '';
            }
            function init() {
                initFilters();
                getDeals();
                $loadMore &&
                    $loadMore.addEventListener('click', () => {
                        $dealsContainer
                            .querySelector('.container-train-card')
                            .setAttribute('data-spinner', '');
                        getDeals();
                    });
                $button &&
                    $button.addEventListener('click', event => {
                        event.preventDefault();
                        showModal();
                    });
                $closeModal &&
                    $closeModal.addEventListener('click', event => {
                        event.preventDefault();
                        hiddenModal();
                    });
            }
            function isMobile() {
                var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                return screenWidth < 768;
            }
            init();
        }
    });
})(Deals || (Deals = {}));
